import React, { useState, useContext, useEffect } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import "../../assets/css/responsive.css";
import { FaPlay, FaCheck } from "react-icons/fa";
import { Form } from "react-bootstrap";
import VideoUpload from "../DashboardComponents/Video/VideoUpload";
import VideoUpload2 from "../DashboardComponents/Video/VideoUpload2";
import IronsData from "../DashboardComponents/IronsData/IronsData";
import ImageUpload from "../DashboardComponents/ImageUpload/ImageUpload";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { ForwardFittingContext } from "./ForwardFittingContext";
import { updateremotefittingdataapi } from "../../Api/contact";
import { getErrorByField, updateUser, addUser } from "../../Api/auth";
import Spinner from 'react-bootstrap/Spinner';
import { useLocation, useHistory } from 'react-router-dom';
import { getUserById } from "../../Api/iron";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { ReactNotifications, Store } from 'react-notifications-component'

function ForewardFitting2() {

    const { remotefittingdata, setRemotefittingdata, updateremotefitting, updateremotefittingfile, remotefittingimage, setRemotefittingimage } = useContext(ForwardFittingContext);

    const [errors, setErrors] = useState([]);
    const [validated, setValidated] = useState(false);
    const [apicall, setApicall] = useState(false);

    const params = useParams();

    const [apicalldata, setApicalldata] = useState(false);

    const [edittrue, setEdittrue] = useState(true);

    const [userid, setUserid] = useState(0);
    const location = useLocation();
    const history = useHistory();
    console.log("location", location);
    const queryParams = new URLSearchParams(location.search);
    const square_id = queryParams.get('userid');
    const [user_id, setuser_id] = useState(0);

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);

    const handleedittrue = () => {
        setEdittrue(!edittrue);
    }

    console.log("edittrue", edittrue);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = ''; // Required for Chrome
            // Custom messages are ignored in most modern browsers
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        const currentUrl = new URL(window.location);
        if (currentUrl.searchParams.has('userid')) {
            currentUrl.searchParams.delete('userid');
            window.history.replaceState(null, '', currentUrl.pathname + currentUrl.search);
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        console.log("remotefittingdata", remotefittingdata);
        console.log("remotefittingimage", remotefittingimage);
    }, [remotefittingdata, remotefittingimage]);

    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: "",
        dexterity: ""
    });

    useEffect(() => {
        getUserById({ _id: params.id }).then((res) => {
            console.log("res", res);
            if (res?.code === 200) {
                setFormData(res.data.data);
                setuser_id(res.data.data._id)
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, firstname: res.data.data.firstname } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, lastname: res.data.data.lastname } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, email: res.data.data.email } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, phone: res.data.data.phone } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, height_ft: res.data.data.height_ft } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, height_in: res.data.data.height_in } });
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }, [params]);

    const [firstvideo, setFirstVideo] = useState(null);
    const [secondvideo, setSecondVideo] = useState(null);

    const dataChange = (e) => {
        const { name, value } = e.target;
        setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, [name]: value } });
        setFormData({ ...formData, [name]: value });
    }

    const handleUpdateSubmit = async (event) => {
        event.preventDefault();
        console.log("event", event);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    }

    const options1 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options2 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options3 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options4 =[
        { id: 1, text: '1' },
        { id: 2, text: '2' },
        { id: 3, text: '3' },
        { id: 4, text: '4' },
        { id: 5, text: '5' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
    ]

    const shortStrike = [
        { id: 1, text: 'Tiger Strike' },
        { id: 2, text: 'No Tiger Strike' },
    ]

    const [currentStep, setCurrentStep] = useState(1);
    const [CheckcurrentStep, setCheckcurrentStep] = useState(0);

    const handleNextStep = () => {
        if (currentStep == 1) {
            const videofirst = remotefittingimage.step0.swing1
            const videosecond = remotefittingimage.step0.swing2;
            if (videofirst && videosecond) {
                setCurrentStep(currentStep + 1);
                setCheckcurrentStep(CheckcurrentStep + 1);
                // window.scrollTo(0, 0);
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 100);

            } else {
                Store.addNotification({
                    title: "Error",
                    message: "Please upload video",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true
                    }
                });
                // window.scrollTo(0, 0);
                setCurrentStep(1);
                setCheckcurrentStep(0);
            }
        }

        if (currentStep == 2) {
            // const step1image = remotefittingimage.step1.location;
            // if (step1image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(2);
            //     setCheckcurrentStep(1);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 3) {
            // const step2image = remotefittingimage.step2.location;
            // if (step2image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(3);
            //     setCheckcurrentStep(2);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 4) {
            // const step3image = remotefittingimage.step3.location;
            // if (step3image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(4);
            //     setCheckcurrentStep(3);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 5) {
            // const step4image = remotefittingimage.step4.location;
            // if (step4image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(5);
            //     setCheckcurrentStep(4);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 6) {
            // const step5image = remotefittingimage.step5.location;
            // if (step5image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(6);
            //     setCheckcurrentStep(5);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 7) {
            // const step6image = remotefittingimage.step6.location;
            // if (step6image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(7);
            //     setCheckcurrentStep(6);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 8) {
            // const step7image = remotefittingimage.step7.location;
            // if (step7image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(8);
            //     setCheckcurrentStep(7);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 9) {
            // const step8image = remotefittingimage.step8.location;
            // if (step8image) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(8);
            //     setCheckcurrentStep(7);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 10) {
            // const notes = remotefittingdata.step8.notes;
            // if (notes) {
            //     setCurrentStep(currentStep + 1);
            //     setCheckcurrentStep(CheckcurrentStep + 1);
            //     window.scrollTo(0, 0);
            // } else {
            //     Store.addNotification({
            //         title: "Error",
            //         message: "Please upload image",
            //         type: "danger",
            //         insert: "top",
            //         container: "top-right",
            //         animationIn: ["animated", "fadeIn"],
            //         animationOut: ["animated", "fadeOut"],
            //         dismiss: {
            //             duration: 3000,
            //             onScreen: true
            //         }
            //     });
            //     // window.scrollTo(0, 0);
            //     setCurrentStep(9);
            //     setCheckcurrentStep(8);
            // }
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }


    };

    const handlePrevStep = () => {
        setCurrentStep(currentStep - 1);
        window.scrollTo(0, 0);
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="step-content-item step-content-item-active w-100 step-1">
                        <div className="step">
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Getting Started</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Watch this to get started</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Before you start watch the video below to a get grasp on what you will be doing and how the process works.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>How do I update my info?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>To edit your info use the form below to update any info that is incorrect. Press save once its corrected.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Launch monitor data setup</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Save and export your session data during the fitting. When we reach out afterwards we will get it via email.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Who to contact for help</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>If you have any issues during the fitting email us at info@foreward.golf and we will give you a call back.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Info</h3>
                                </div>
                                {/* <div class="content-box-btn">
                                    <button class="btn btn-add" onClick={handleedittrue}> {userid == 0 ? "Add" : "Edit"} </button>
                                </div> */}
                            </div>
                            <div className="dashboard-sec">
                                <div className="container-fulid">
                                    <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                        <fieldset>
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                // placeholder="Name"
                                                                disabled={edittrue}
                                                                value={formData.firstname}
                                                                name={"firstname"}
                                                                onChange={(e) => dataChange(e)}
                                                            />
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="Last"
                                                                name={"lastname"}
                                                                disabled={edittrue}
                                                                value={formData.lastname}
                                                                onChange={(e) => dataChange(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                // placeholder="Email Address"
                                                                name="email"
                                                                className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                disabled={edittrue}
                                                                value={formData.email}
                                                                onChange={(e) => dataChange(e)}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                        return item.detail;
                                                                    }) : "Please enter valid email"
                                                                }
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group mb-0">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <div className="w-100">
                                                                <input type="number"
                                                                    name={"phone"}
                                                                    // placeholder="Phone Number"
                                                                    required
                                                                    disabled={edittrue}
                                                                    className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                                    value={formData.phone}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid phone number"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </Form>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Height</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="form-box-section mt-4">
                                    <div className="form-item height-form-iteam">
                                        <div className="form-group custom-form-group mb-0">
                                            <label className="dashboard-form-lable">Height</label>
                                            <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                {/* <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_ft"} value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">ft.</label>
                                                    <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_in"} value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">in.</label> */}
                                                <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={edittrue} name={"height_ft"} value={formData.height_ft} onChange={(e) => dataChange(e)} aria-label="Default select example">
                                                    <option value={0}>ft.</option>
                                                    <option value="4">4 ft.</option>
                                                    <option value="5">5 ft.</option>
                                                    <option value="6">6 ft.</option>
                                                    <option value="7">7 ft.</option>
                                                </select>
                                                <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={edittrue} name={"height_in"} value={formData.height_in} onChange={(e) => dataChange(e)} aria-label="Default select example">
                                                    <option value={0}>in.</option>
                                                    <option value="1">0 in.</option>
                                                    <option value="2">1 in.</option>
                                                    <option value="3">2 in.</option>
                                                    <option value="4">3 in.</option>
                                                    <option value="5">4 in.</option>
                                                    <option value="6">5 in.</option>
                                                    <option value="7">6 in.</option>
                                                    <option value="8">7 in.</option>
                                                    <option value="9">8 in.</option>
                                                    <option value="10">9 in.</option>
                                                    <option value="11">10 in.</option>
                                                    <option value="12">11 in.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Dexterity</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="form-box-section mt-4">
                                    <div className="form-item height-form-iteam">
                                        <div className="form-group custom-form-group mb-0">
                                            <label className="dashboard-form-lable">Dexterity</label>
                                            <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                {/* <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_ft"} value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">ft.</label>
                                                    <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_in"} value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">in.</label> */}
                                                <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={edittrue} name={"dexterity"} value={formData.dexterity} onChange={(e) => dataChange(e)} aria-label="Default select example">
                                                    <option value={0}>Dexterity</option>
                                                    <option value="1">Right Handed</option>
                                                    <option value="2">Left Handed</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Swing</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Film and send your swing</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>The first thing we need is videos of your swing. Watch the video below to ensure we are getting the right angles.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What camera do I use?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Just use your cell phone! We don’t need slo mo videos. Just hold it vertically and film your angles.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is the proper angle?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Please watch the video above for directions. Camera is held at naval height from DTL and FO angles.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>If it’s not your best swing?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This isn’t the end of the world. We are looking at face to path ratios. We will see what we need to.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_dark">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-center gap-2">
                                                <VideoUpload step="step0" onfilechange={(editfile) => setFirstVideo(editfile)} />
                                                <VideoUpload2 step="step0" onfilechange={(editfile) => setSecondVideo(editfile)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Component Testing</h3>
                                </div>

                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Let’s start testing clubs</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Its time to start testing irons. Watch the video below to get an overview of how to go through the process.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Do I need to go in order?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Yes. The interface won’t allow you to skip any steps. We designed this process to work in order.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>How to take strike photos?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Watch the video! We just need all three sprayed clubs of the section laid down and photographed.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is a preferred club?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This is purely subjective. We want to know which option felt the best to you. No data, just feels.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="step-content-item w-100 step-2">
                        <div className="sec-header-dash white">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> White Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step1" iron="iron1" title="White Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step1" iron="iron2" title="White Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step1" iron="iron3" title="White Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step1" title="White" />
                    </div>
                );
            case 3:
                return (
                    <div className="step-content-item black w-100 step-3">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Black Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step2" iron="iron1" title="Black Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step2" iron="iron2" title="Black Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step2" iron="iron3" title="Black Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step2" title="Black" />
                    </div>
                );
            case 4:
                return (
                    <div className="step-content-item blue w-100 step-4">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Blue Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step3" iron="iron1" title="Blue Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} />
                            <IronsData step="step3" iron="iron2" title="Blue Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step3" iron="iron3" title="Blue Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step3" title="Blue" />
                    </div>
                );
            case 5:
                return (
                    <div className="step-content-item pink w-100 step-5">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Pink Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step4" iron="iron1" title="Pink Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step4" iron="iron2" title="Pink Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step4" iron="iron3" title="Pink Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step4" title="Pink" />
                    </div>
                );
            case 6:
                return (
                    <div className="step-content-item purpal w-100 step-6">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Purple Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step5" iron="iron1" title="Purple Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step5" iron="iron2" title="Purple Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step5" iron="iron3" title="Purple Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step5" title="Purple" />
                    </div>
                );
            case 7:
                return (
                    <div className="step-content-item red w-100 step-7">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Red Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step6" iron="iron1" title="Red Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step6" iron="iron2" title="Red Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step6" iron="iron3" title="Red Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step6" title="Red" />
                    </div>
                );
            case 8:
                return (
                    <div className="step-content-item orange w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Orange Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step7" iron="iron1" title="Orange Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step7" iron="iron2" title="Orange Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step7" iron="iron3" title="Orange Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step7" title="Orange" />
                    </div>
                );
            case 9:
                return (
                    <div className="step-content-item green w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Green Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step8" iron="iron1" title="Green Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step8" iron="iron2" title="Green Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                            <IronsData step="step8" iron="iron3" title="Green Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4}/>
                        </div>
                        <ImageUpload step="step8" title="Green" />
                    </div>
                );
            case 10:
                return (
                    <div className="step-content-item w-100 step-9">
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Finishing Up</h3>
                            </div>
                        </div>
                        <div class="dashboard-sec">
                            <div className="bg_color_sec">
                                <div className="row align-items-center mb-5">
                                    <div className="col-md-6">
                                        <div class="box-step-content admin-box">
                                            <div class="box-title">
                                                <h4>What happens now?</h4>
                                            </div>
                                            <div class="box-text">
                                                <p>Before you submit your fitting leave us some notes below. Once you submit this our team will be in contact.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div class="box-step-img">
                                            <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                            <div className="play_icon">
                                                <div className="play_icon_item">
                                                    <FaPlay />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Accordion>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="0" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What are the notes for?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We want to understand what you thought and felt during testing. Whatever it is leave it for us!</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="1" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What happens after this?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We are going to talk. We will reach our via email to dial you in and get you your prescription.</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="2" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What will you receive?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>You will get a full prescription of what we would build you. No loyalty to any brand, not even ours.</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                        </div>
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Your Notes</h3>
                            </div>
                        </div>

                        <div className="dashboard-sec">
                            <div className="form-box-section mb-3">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" onChange={(e) => { updateremotefitting(`step9.notes`, e.target.value) }} placeholder="Leave your note here..."></textarea>
                            </div>
                        </div>

                        <buton className="btn btn-colr-white active mt-3 mb-3 d-flex justify-content-center align-items-center btn-fitting-submit" onClick={() => updateremotefittingdata()}>{apicalldata ? (<Spinner animation="border" className="border-black" />) : (<span>Submit Your Fitting</span>)}</buton>
                    </div>
                );
            default:
                return null;
        }
    };

    const currentStepName = () => {
        switch (currentStep) {
            case 1:
                return "Get Started";
            case 2:
                return "Get Started";
            case 3:
                return "White Irons";
            case 4:
                return "Black Irons";
            case 5:
                return "Blue Irons";
            case 6:
                return "Pink Irons";
            case 7:
                return "Purple Irons";
            case 8:
                return "Red Irons";
            case 9:
                return "Orange Irons";
            case 10:
                return "Green Irons";

            default:
                return null;
        }
    };

    const nextStepName = () => {
        switch (currentStep + 1) {
            case 2:
                return "White Irons";
            case 3:
                return "Black Irons";
            case 4:
                return "Blue Irons";
            case 5:
                return "Pink Irons";
            case 6:
                return "Purple Irons";
            case 7:
                return "Red Irons";
            case 8:
                return "Orange Irons";
            case 9:
                return "Green Irons";
            case 10:
                return "Finish Up";
            case 11:
                return "Submit Fitting";

            default:
                return null;
        }
    };

    const updateremotefittingdata = () => {

        setApicalldata(true);
        const formData = new FormData();
        formData.append('remotefittingdata', JSON.stringify(remotefittingdata));
        formData.append('email', formData.email);
        formData.append('user_id', params.id);
        formData.append('square_id', square_id);
        formData.append('fitting_type', "remotefitting");

        if (remotefittingimage) {
            if (remotefittingimage.step0.swing1 instanceof File) {
                formData.append('video', remotefittingimage.step0.swing1);
            }
            if (remotefittingimage.step0.swing2 instanceof File) {
                formData.append('video', remotefittingimage.step0.swing2);
            }
            if (remotefittingimage.step1.location instanceof File) {
                formData.append('image', remotefittingimage.step1.location);
            }
            if (remotefittingimage.step2.location instanceof File) {
                formData.append('image', remotefittingimage.step2.location);
            }
            if (remotefittingimage.step3.location instanceof File) {
                formData.append('image', remotefittingimage.step3.location);
            }
            if (remotefittingimage.step4.location instanceof File) {
                formData.append('image', remotefittingimage.step4.location);
            }
            if (remotefittingimage.step5.location instanceof File) {
                formData.append('image', remotefittingimage.step5.location);
            }
            if (remotefittingimage.step6.location instanceof File) {
                formData.append('image', remotefittingimage.step6.location);
            }
            if (remotefittingimage.step7.location instanceof File) {
                formData.append('image', remotefittingimage.step7.location);
            }
            if (remotefittingimage.step8.location instanceof File) {
                formData.append('image', remotefittingimage.step8.location);
            }
        }

        updateremotefittingdataapi(formData).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicalldata(false);
                handleShow02();

                setTimeout(() => {
                    window.location.href = "/user-dashboard";
                }, 2000);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const addUseruserdata = async () => {
        try {
            setApicall(true);
            const data = {
                email: remotefittingdata.step0.email,
                firstname: remotefittingdata.step0.firstname,
                lastname: remotefittingdata.step0.lastname,
                phone: remotefittingdata.step0.phone,
                height_ft: remotefittingdata.step0.height_ft,
                height_in: remotefittingdata.step0.height_in,
                password: "123456"
            }
            const res = await addUser(data);
            if (!res.data.status) {
                setErrors(res.data.error);
                setApicall(false);
                return false;
            } else {
                setErrors([]);
                setUserid(res.data.data.square_id);
                setuser_id(res.data.data._id);
                history.push(`/remote_fitting?userid=${res.data.data.square_id}`);
                setApicall(false);
                return true;
            }

        } catch (error) {
            setApicall(false);
            console.log("error", error);
        }
    }


    const updateuserdata = async () => {
        try {
            setApicall(true);
            const data = {
                _id: user_id,
                email: formData.email,
                square_id: square_id,
                firstname: formData.firstname,
                lastname: formData.lastname,
                phone: formData.phone,
                height_ft: formData.height_ft,
                height_in: formData.height_in,
            }
            const res = await updateUser(data);
            if (!res.data.status) {
                setErrors(res.data.error);
                setApicall(false);
                return false;
            } else {
                setErrors([]);
                setApicall(false);
                return true;
            }

        } catch (error) {
            setApicall(false);
            console.log("error", error);
        }
    }

    return (
        <>
            <ReactNotifications />
            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmitClubOrder.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your Fitting is added
                    </h3>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div>
                                        <div className="step-btn">
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-left-btn"
                                                    onClick={handlePrevStep}
                                                    disabled={currentStep === 1}
                                                >
                                                    {currentStep !== 1 && <FaChevronLeft />}
                                                    <div className="pr_content m-0 step_pr_content">
                                                        <h6>Step {currentStep - +1}</h6>
                                                        <h4>{currentStepName()}</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div className="step-btn-item">
                                                {currentStep === 1 && apicall ? (
                                                    <button
                                                        className="btn step-btn-view step-right-btn"
                                                    >
                                                        <Spinner animation="border" className="border-white" />
                                                    </button>

                                                ) : (
                                                    <button
                                                        className="btn step-btn-view step-right-btn"
                                                        onClick={handleNextStep}
                                                        disabled={currentStep === 10}
                                                    >
                                                        <div className="pr_content m-0 step_pr_content text-right">
                                                            <h6>Step {currentStep + 1}</h6>
                                                            <h4>{nextStepName()}</h4>
                                                        </div>
                                                        {currentStep !== 10 && <FaChevronRight />}
                                                    </button>
                                                )}

                                                {/* <button
                                                    className="btn step-btn-view step-right-btn"
                                                    onClick={handleNextStep}
                                                    disabled={currentStep === 9}
                                                >
                                                    <div className="pr_content m-0 step_pr_content text-right">
                                                        <h6>Step {currentStep + 1}</h6>
                                                        <h4>{nextStepName()}</h4>
                                                    </div>
                                                    {currentStep !== 9 && <FaChevronRight />}
                                                </button> */}
                                            </div>
                                        </div>
                                        <div className="step-content">{renderStepContent()}</div>
                                        <div className="step-btn">
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-left-btn"
                                                    onClick={handlePrevStep}
                                                    disabled={currentStep === 1}
                                                >
                                                    {currentStep !== 1 && <FaChevronLeft />}
                                                    <div className="pr_content m-0 step_pr_content">
                                                        <h6>Step {currentStep - +1}</h6>
                                                        <h4>{currentStepName()}</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div className="step-btn-item">
                                                {currentStep === 1 && apicall ? (
                                                    <button
                                                        className="btn step-btn-view step-right-btn"
                                                    >
                                                        <Spinner animation="border" className="border-white" />
                                                    </button>

                                                ) : (
                                                    <button
                                                        className="btn step-btn-view step-right-btn"
                                                        onClick={handleNextStep}
                                                        disabled={currentStep === 10}
                                                    >
                                                        <div className="pr_content m-0 step_pr_content text-right">
                                                            <h6>Step {currentStep + 1}</h6>
                                                            <h4>{nextStepName()}</h4>
                                                        </div>
                                                        {currentStep !== 10 && <FaChevronRight />}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForewardFitting2;


